import { DS_STACKED_OVERLAYS } from '~/composables/ds/useDsAnchoredOverlay';

const HOSTED_IN_FIXED_CONTAINER = '[role="dialog"], .gd-modal-scrim';
// Sampling is skipped while the anchor's top sits in the lower part of the viewport.
const SAMPLE_BELOW_FRACTION = 0.4;

function pinnedAncestor (start: Element): Element | null {
  for (let el: Element | null = start; el; el = el.parentElement) {
    const { position } = getComputedStyle(el);
    if (position === 'sticky' || position === 'fixed') { return el; }
  }
  return null;
}

// Chrome stacks several sticky bars (topbar, sub-nav, notice): the walk goes down the stack.
const MAX_STACKED_BARS = 6;

function coverAt (anchor: HTMLElement, x: number, y: number): Element | null {
  const covering = document.elementsFromPoint(x, y).find(el => !el.closest(`${DS_STACKED_OVERLAYS}, .gd-ce-spot`));
  if (!covering || anchor.contains(covering)) { return null; }
  const pinned = pinnedAncestor(covering);
  return pinned && !pinned.contains(anchor) ? pinned : null;
}

// Bottom edge, in viewport px, of the sticky or fixed chrome covering the top edge of `anchor`, or 0.
export function measureStickyInset (anchor: HTMLElement, rect: DOMRect): number {
  if (rect.top >= window.innerHeight * SAMPLE_BELOW_FRACTION) { return 0; }
  if (anchor.closest(HOSTED_IN_FIXED_CONTAINER)) { return 0; }
  const x = Math.max(0, Math.min(rect.left + rect.width / 2, window.innerWidth - 1));
  let inset = 0;
  let y = Math.max(0, rect.top + 1);
  for (let bar = 0; bar < MAX_STACKED_BARS; bar++) {
    const pinned = coverAt(anchor, x, y);
    const bottom = pinned?.getBoundingClientRect().bottom ?? 0;
    if (bottom <= inset) { break; }
    inset = bottom;
    y = inset + 1;
  }
  return inset;
}
